import { render } from "./FacebookRedirectView.vue?vue&type=template&id=8aa6519e&scoped=true"
import script from "./FacebookRedirectView.vue?vue&type=script&lang=js"
export * from "./FacebookRedirectView.vue?vue&type=script&lang=js"

import "./FacebookRedirectView.vue?vue&type=style&index=0&id=8aa6519e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa6519e"]])

export default __exports__